angular.module('dnecom').controller('CampaignModalController', ["$scope", "campaign", "$uibModalInstance", function($scope, campaign, $uibModalInstance) {
    $scope.emailTemplates = TemplateData.value('emailTemplates');
    $scope.campaign = campaign;
    $scope.defaultTimeouts = [
        {days: 0, hours: 0, minutes: 15},
        {days: 0, hours: 5, minutes: 0},
        {days: 1, hours: 0, minutes: 0},
        {days: 2, hours: 0, minutes: 0},
        {days: 3, hours: 0, minutes: 0}
    ];

    if (_.isArray($scope.campaign.triggerCondition)) {
        $scope.campaign.triggerCondition = {};
    }

    $scope.conditions = [
        {
            type: 'cart-amount',
            label: 'Total amount in cart',
            options: [
                {
                    type: 'more-than',
                    label: 'more than'
                },
                {
                    type: 'less-than',
                    label: 'less than'
                },
                {
                    type: 'equal',
                    label: 'equal to'
                },
                {
                    type: 'range',
                    label: 'in range'
                }
            ]
        },
        {
            type: 'cart-items-count',
            label: 'Total number of items in cart',
            options: [
                {
                    type: 'more-than',
                    label: 'more than'
                },
                {
                    type: 'less-than',
                    label: 'less than'
                },
                {
                    type: 'equal',
                    label: 'equal to'
                },
                {
                    type: 'range',
                    label: 'in range'
                }
            ]
        },
        {
            type: 'date-range',
            label: 'Date Range'
        },
        {
            type: 'specific-date',
            label: 'Specific Date'
        }
    ];

    $scope.optionChanged = function() {
        if ($scope.campaign.triggerCondition.option === 'range') {
            $scope.campaign.triggerCondition.value = {};
        } else {
            $scope.campaign.triggerCondition.value = null;
        }
    };

    $scope.typeChanged = function() {
        if ($scope.campaign.triggerCondition.type === 'date-range') {
            $scope.campaign.triggerCondition.value = {};
        } else {
            $scope.campaign.triggerCondition.value = null;
        }
    };

    $scope.getOptionsForType = function(type) {
        var options = [];
        for (var i = 0; i < $scope.conditions.length; i++) {
            if ($scope.conditions[i].type === type) {
                options = $scope.conditions[i].options;
            }
        }

        return options;
    };

    $scope.addEmail = function() {
        var count = campaign.campaignEmails.length;
        if (campaign.campaignEmails.length >= 5) {
            return;
        }

        if (_.isUndefined($scope.defaultTimeouts[count])) {
            var timeout = $scope.defaultTimeouts[0];
        } else {
            var timeout = $scope.defaultTimeouts[count]
        }

        campaign.campaignEmails.push({campaign: campaign.id, timeout: timeout});
    };

    $scope.removeEmail = function(index) {
        campaign.campaignEmails.splice(index, 1);
    };

    $scope.cancel = function() {
        $uibModalInstance.dismiss('cancel');
    };

    $scope.save = function() {
        if ($scope.campaignForm.$invalid) {
            angular.forEach($scope.campaignForm.$error, function(field) {
                angular.forEach(field, function(errorField) {
                    errorField.$setTouched();
                });
            });

            return;
        }

        $uibModalInstance.close({
            campaign: $scope.campaign
        });
    };
}]);
